import React from 'react'
import Arrow from '../../img/ui/ui-arrow-top.svg'
import './style.css'

const ArrowToTop = () => {
  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return (
    <a href="#top" className="top-link" onClick={scrollToTop}>
				<span className="top-link__text">To Top</span>
				<div className="top-link__icon">
					<img src={Arrow} alt="" aria-hidden="true" width={14} height={16} className="top-link__img" />
				</div>
		</a>
  )
}

export default ArrowToTop;